import * as React from 'react';
import { ArrowChevronRight, ArrowChevronUp } from '../../icons';
import { Item, Trigger, TriggerContent, Content } from './ExpandableList.styles';
function handleClick(setState, state, cb) {
    return function () {
        var newState = !state;
        setState(newState);
        if (cb !== undefined) {
            cb(newState);
        }
    };
}
/**
 * Provides an expandable list item.
 */
export var ExpandableItem = function (props) {
    var renderHeader = props.renderHeader, arrow = props.arrow, expanded = props.expanded, onClick = props.onClick, children = props.children, testId = props.testId;
    var _a = React.useState(Boolean(expanded)), isExpanded = _a[0], setIsExpanded = _a[1];
    var _b = React.useState(false), childrenMounted = _b[0], setChildrenMounted = _b[1];
    /**
     * This effect ensures that the expanded state of this
     * component is only applied once the child components
     * have finished being mounted, as effects are run *after*
     * the component has been mounted.
     *
     * Why? To avoid any flashes of this component's expanded
     * state while the child components haven't yet been processed.
     */
    React.useEffect(function () {
        setChildrenMounted(isExpanded);
    }, [isExpanded]);
    return (React.createElement(Item, { expanded: childrenMounted && isExpanded, className: childrenMounted && isExpanded ? 'expanded-item' : '', "data-testid": testId },
        React.createElement(Trigger, { onClick: handleClick(setIsExpanded, isExpanded, onClick) },
            renderHeader !== null && (React.createElement(TriggerContent, null, renderHeader)),
            arrow !== null &&
                (childrenMounted && isExpanded ? (React.createElement(ArrowChevronUp, null)) : (React.createElement(ArrowChevronRight, null)))),
        isExpanded && (React.createElement(Content, { hidden: !childrenMounted }, children))));
};
ExpandableItem.defaultProps = {
    expanded: false,
    arrow: true
};
//# sourceMappingURL=ExpandableItem.js.map